module.exports = __webpack_public_path__ + "static/media/success@3x.21c5c050.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/success@3x.png
// module id = 32
// module chunks = 0